// ~/composables/useFormattedYoutubeUrl.ts
import { computed } from "vue";

interface YoutubeUrlOptions {
  autoplay?: boolean;
  muted?: boolean;
  rel?: boolean; // show related videos
}

export function useFormattedYoutubeUrl(
  youtubeUrl: string,
  options: YoutubeUrlOptions = {},
) {
  const { autoplay = false, muted = false, rel = false } = options;

  const formattedUrl = computed(() => {
    if (!youtubeUrl) return "";

    const autoplayVal = autoplay ? "1" : "0";
    const muteVal = muted ? "1" : "0";
    const relVal = rel ? "1" : "0";

    const queryParams = `autoplay=${autoplayVal}&mute=${muteVal}&rel=${relVal}`;

    if (youtubeUrl.includes("youtube.com/embed/")) {
      const separator = youtubeUrl.includes("?") ? "&" : "?";
      let url = youtubeUrl.replace(/([&?])(autoplay|mute|rel)=\d+&?/g, "$1");
      url = url.replace(/[?&]$/, "");
      return `${url}${separator}${queryParams}`;
    }

    const videoId = youtubeUrl.match(
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/,
    )?.[1];
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}?${queryParams}`;
    }

    return youtubeUrl;
  });

  return {
    formattedUrl,
  };
}
